var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wangeditor"},[_c('div',{ref:"toolbar",staticClass:"toolbar",style:({width:_vm.width})}),_c('div',{ref:"wangeditor",staticClass:"text",style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }